module.exports = __webpack_public_path__ + "img/logo-rabota.bd0d5ede.svg";